// originally from edit-image-common-style in ui-next/common-styles

export const getMsanPreviewStyles = () => ({
  '& .new-responsive-ad-preview-container .additional-disclaimer': {
    position: 'absolute',
    bottom: 35,
    fontSize: 12,
    textAlign: 'center',
    width: '100%',
  },
  '& .new-responsive-ad-preview-container .text-container': {
    bottom: 25,
    left: 20,
    fontSize: 10,
    lineHeight: '16px',
  },
  // '& .new-responsive-ad-preview-container .text-container .short-headline': {
  //   overflow: 'hidden',
  //   fontWeight: '200',
  //   paddingBottom: 1,
  // },
  '& .new-responsive-ad-preview-container .text-container .short-headline': {
    fontWeight: '200',
    fontSize: 20,
    paddingBottom: 5,
  },
  '& .new-responsive-ad-preview-container .text-container .business-name-with-ads': {
    marginTop: 9,
    padding: '1px 0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '& .new-responsive-ad-preview-container .text-container .business-name-with-ads .business-name': {
    fontSize: 11,
    lineHeight: '1.364',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel .text-container, .new-responsive-ad-preview-container .msn-single-carousel-v2 .text-container, .new-responsive-ad-preview-container .edge-single-carousel .text-container, .new-responsive-ad-preview-container .msn-double-carousel .text-container, .new-responsive-ad-preview-container .edge-medium-headline .text-container': {
    position: 'absolute',
    color: '#bebebe',
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel .text-container .long-headline, .new-responsive-ad-preview-container .msn-single-carousel-v2 .text-container .long-headline, .new-responsive-ad-preview-container .edge-single-carousel .text-container .short-headline, .new-responsive-ad-preview-container .msn-double-carousel .text-container .long-headline, .new-responsive-ad-preview-container .edge-medium-carousel .text-container .long-headline': {
    color: 'white',
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel .text-container .short-headline, .new-responsive-ad-preview-container .msn-single-carousel-v2 .text-container .short-headline, .new-responsive-ad-preview-container .edge-single-carousel .text-container .short-headline, .new-responsive-ad-preview-container .msn-double-carousel .text-container .short-headline, .new-responsive-ad-preview-container .edge-medium-headline .text-container .short-headline': {
    color: 'white',
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel .gradient::after, .new-responsive-ad-preview-container .msn-single-carousel-v2 .gradient::after, .new-responsive-ad-preview-container .edge-single-carousel .gradient::after, .new-responsive-ad-preview-container .msn-double-carousel .gradient::after': {
    display: 'block',
    position: 'relative',
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
    marginTop: -250,
    height: 280,
    width: '100%',
    content: '\'\'',
  },
  '& .new-responsive-ad-preview-container .boost-windows': {
    border: 'none',
    '& .hardcode-time': {
      flexDirection: 'column',
      alignItems: 'center',
      position: 'absolute',
      display: 'flex',
      justifyContent: 'space-between',
      top: 20,
      left: '50%',
      color: 'white',
      transform: 'translate(-50%)',
      '& .welcome': {
        marginBottom: 10,
      },
      '& .time': {
        fontSize: 40,
      },
    },
    '& .text-container': {
      display: 'flex',
      right: 80,
      top: 20,
      color: 'white',
      bottom: 'unset',
      left: 'unset',
      padding: 10,
      fontSize: 8,
      position: 'absolute',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: 130,
      height: 130,
      backgroundColor: '#272a14',
      opacity: 0.8,
      borderRadius: 5,
    },
    '& .hotspot0': {
      position: 'absolute',
      color: 'white',
      top: 20,
      left: 80,
      display: 'flex',
      padding: 10,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: 130,
      height: 130,
      fontSize: 8,
      backgroundColor: '#272a14',
      opacity: 0.8,
      borderRadius: 5,
      '& .hotspot-action': {
        marginTop: 10,
        curosr: 'pointer',
      },
    },
    '& .hotspot1': {
      position: 'absolute',
      color: 'white',
      top: '50%',
      left: '50%',
      padding: 10,
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: 130,
      height: 130,
      fontSize: 8,
      backgroundColor: '#272a14',
      opacity: 0.8,
      borderRadius: 5,
      '& .hotspot-action': {
        marginTop: 10,
        curosr: 'pointer',
      },
    },
    '& .hotspot2': {
      position: 'absolute',
      color: 'white',
      top: 250,
      right: 80,
      padding: 10,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: 130,
      height: 130,
      fontSize: 8,
      backgroundColor: '#272a14',
      opacity: 0.8,
      borderRadius: 5,
      '& .hotspot-action': {
        marginTop: 10,
        curosr: 'pointer',
      },
    },
  },
  '& .new-responsive-ad-preview-container .boost-discover-card': {
    width: 280,
    height: 400,
    borderRadius: 5,
    '& .hardcode-discover': {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      fontSize: 16,
      color: 'black',
      borderBottom: '1px solid #C8C8C8',
      paddingLeft: 10,
    },
    '& .image-container': {
      position: 'absolute',
      left: '50%',
      top: 27,
      transform: 'translateX(-50%)',
    },
    '& .short-headline': {
      left: 15,
      top: 288,
      position: 'absolute',
      width: 250,
      fontSize: 12,
      fontWeight: 'bold',
      color: 'black',
    },
    '& .description': {
      left: 15,
      top: 310,
      fontSize: 12,
      position: 'absolute',
      color: 'black',
    },
    '& .action-button': {
      backgroundColor: 'transparent',
      position: 'absolute',
      left: 15,
      top: 353,
      padding: 0,
      fontSize: 12,
      border: 'none',
      borderRadius: 5,
    },
  },
  '& .new-responsive-ad-preview-container .boost-start-menu': {
    width: 280,
    height: 60,
    backgroundColor: '#262632',
    '& .logo-container': {
      position: 'absolute',
      top: '50%',
      left: 10,
      transform: 'translateY(-50%)',
    },
    '& .short-headline': {
      position: 'absolute',
      top: 0,
      left: 0,
      fontSize: 12,
      width: 200,
      color: 'white',
    },
    '& .long-headline': {
      position: 'absolute',
      top: 15,
      left: 40,
      fontSize: 12,
      color: 'white',
    },
  },
  '& .new-responsive-ad-preview-container .boost-actionCenter': {
    width: 280,
    height: 150,
    backgroundColor: '#e8e9eb',
    '& .logo-container': {
      position: 'absolute',
      top: 20,
      left: 20,
    },
    '& .short-headline': {
      position: 'absolute',
      top: 20,
      left: 80,
      width: 180,
      fontSize: 12,
      color: 'black',
      fontWeight: 'bold',
    },
    '& .description': {
      position: 'absolute',
      top: 50,
      fontSize: 12,
      left: 80,
      width: 180,
      color: 'black',
    },
    '& .action-button': {
      position: 'absolute',
      left: 20,
      top: 120,
      color: 'black',
      width: 120,
      backgroundColor: 'white',
      border: 'none',
      height: 20,
    },
    '& .dismiss-button': {
      position: 'absolute',
      left: 150,
      top: 120,
      width: 120,
      color: 'black',
      backgroundColor: 'white',
      border: 'none',
      height: 20,
    },
  },
  '& .new-responsive-ad-preview-container .boost-coachmark': {
    width: 280,
    height: 300,
    '& .short-headline': {
      left: 20,
      top: 180,
      position: 'absolute',
      fontWeight: 'bold',
      color: 'black',
    },
    '& .description': {
      left: 20,
      top: 210,
      fontSize: 20,
      position: 'absolute',
      color: 'black',
    },
    '& .action-button': {
      backgroundColor: '#0078d4',
      position: 'absolute',
      left: 20,
      top: 260,
      padding: 8,
      fontSize: 15,
      border: 'none',
      color: 'white',
      borderRadius: 5,
    },
  },
  '& .new-responsive-ad-preview-container .boost-banner': {
    height: 35,
    width: 600,
    '& .logo-container': {
      position: 'absolute',
      top: '50%',
      left: 10,
      transform: 'translateY(-50%)',
    },
    '& .short-headline': {
      position: 'absolute',
      top: '50%',
      left: 40,
      fontSize: 12,
      color: 'black',
      transform: 'translateY(-50%)',
      width: 220,
    },
    '& .action-button': {
      position: 'absolute',
      top: '50%',
      left: 450,
      padding: '5px 10px',
      border: 'none',
      color: 'white',
      borderRadius: 10,
      backgroundColor: '#0078d4',
      transform: 'translateY(-50%)',
    },
    '& .dismiss-button': {
      position: 'absolute',
      top: '50%',
      left: 520,
      border: 'none',
      padding: '5px 10px',
      borderRadius: 10,
      color: 'black',
      transform: 'translateY(-50%)',
    },
  },
  '& .new-responsive-ad-preview-container .boost-191X1': {
    width: 268,
    height: 270,
    background: '#262632 !important',
    borderRadius: 8,
    '& .image-container': {
      position: 'absolute',
      width: '100%',
      height: 140,
      top: 0,
    },
    '& .long-headline': {
      position: 'absolute',
      width: 250,
      fontSize: 18,
      left: 20,
      top: 180,
      color: 'white',
      fontWeight: 600,
    },
    '& .business-name-with-ads': {
      position: 'absolute',
      top: 140,
      left: 20,
      color: 'white',
    },
  },
  '& .new-responsive-ad-preview-container .video-ad-text .business-name-with-ads .adslabel': {
    fontSize: 11,
    lineHeight: '1.364',
    margin: '0 5px 0 0',
    background: '#1e6525',
    borderRadius: 2,
    color: '#fff',
    fontFamily: '"Segoe UI","Segoe WP",Arial,Sans-Serif',
    fontWeight: '400',
    padding: '1.2px 6px 1.8px 6px',
    width: 'auto',
  },
  '& .new-responsive-ad-preview-container .edge-medium-headline .gradient::after': {
    display: 'block',
    position: 'relative',
    backgroundImage: 'linear-gradient(to bottom, transparent 0, rgb(46, 46, 46) 100%)',
    marginTop: -279,
    height: 280,
    width: '100%',
    content: '\'\'',
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel:hover, .new-responsive-ad-preview-container .msn-single-carousel-v2:hover, .new-responsive-ad-preview-container .edge-single-carousel:hover,  .new-responsive-ad-preview-container .msn-double-carousel:hover, .new-responsive-ad-preview-container .edge-medium-headline:hover': {
    cursor: 'pointer',
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel:hover .long-headline, .new-responsive-ad-preview-container .msn-single-carousel-v2:hover .long-headline, .new-responsive-ad-preview-container .edge-single-carousel:hover .long-headline, .new-responsive-ad-preview-container .msn-double-carousel:hover .long-headline, .new-responsive-ad-preview-container .msn-single-carousel:hover .short-headline, .new-responsive-ad-preview-container .edge-single-carousel:hover .short-headline, .new-responsive-ad-preview-container .msn-double-carousel:hover .short-headline': {
    textDecoration: 'underline',
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel:hover .gradient::after, .new-responsive-ad-preview-container .msn-single-carousel-v2:hover .gradient::after, .new-responsive-ad-preview-container .edge-single-carousel:hover .gradient::after, .new-responsive-ad-preview-container .msn-double-carousel:hover .gradient::after, .new-responsive-ad-preview-container .edge-medium-headline:hover .gradient::after': {
    marginTop: -450,
    height: 480,
  },
  '& .new-responsive-ad-preview-container .audience-network-wide, .new-responsive-ad-preview-container .msn-medium-headline, .new-responsive-ad-preview-container .msn-in-article, .new-responsive-ad-preview-container .msn-small-headline, .new-responsive-ad-preview-container .msn-restoday, .new-responsive-ad-preview-container .audience-network-square-image, .new-responsive-ad-preview-container .msn-partner-stripe, .new-responsive-ad-preview-container .audience-network-banner, .new-responsive-ad-preview-container .mobile-web-outlook': {
    margin: 'auto',
    background: '#fff',
    border: 'solid',
    borderWidth: 'thin',
    color: '#ddd',
  },
  '& .new-responsive-ad-preview-container .audience-network-rectangle .text-container': {
    position: 'absolute',
    // color: '#bebebe',
  },
  '& .new-responsive-ad-preview-container .audience-network-rectangle .gradient::after': {
    display: 'block',
    position: 'relative',
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
    marginTop: -250,
    height: 280,
    width: '100%',
    content: '\'\'',
  },
  '& .new-responsive-ad-preview-container .audience-network-rectangle:hover': {
    cursor: 'pointer',
  },
  '& .new-responsive-ad-preview-container .audience-network-rectangle:hover .short-headline': {
    textDecoration: 'underline',
  },
  '& .new-responsive-ad-preview-container .audience-network-rectangle:hover .gradient::after': {
    marginTop: -450,
    height: 480,
  },
  '& .new-responsive-ad-preview-container .audience-network-rectangle': {
    width: 300,
    height: 250,
  },
  '& .new-responsive-ad-preview-container .audience-network-rectangle .text-container .short-headline': {
    fontSize: 20,
    fontWeight: 200,
    fontFamily: 'Segoe UI Semibold',
    width: 268,
    marginBottom: 20,
    lineHeight: '26px',
    color: '#fff',
  },
  '& .new-responsive-ad-preview-container .audience-network-rectangle .text-container .long-headline .multi-line-processed-text': {
    position: 'absolute',
    bottom: 30,
  },
  '& .new-responsive-ad-preview-container .audience-network-wide .text-container, .new-responsive-ad-preview-container .audience-network-rectangle .text-container, .new-responsive-ad-preview-container .msn-medium-headline .text-container, .new-responsive-ad-preview-container .msn-in-article .text-container, .new-responsive-ad-preview-container .msn-small-headline .text-container, .new-responsive-ad-preview-container .msn-restoday .text-container, .new-responsive-ad-preview-container .audience-network-square-image .text-container, .new-responsive-ad-preview-container .msn-partner-stripe .text-container, .new-responsive-ad-preview-container .audience-network-banner .text-container, .new-responsive-ad-preview-container .mobile-web-outlook .text-container': {
    color: '#333',
  },
  '& .new-responsive-ad-preview-container .audience-network-wide .text-container .business-name-with-ads .business-name, .new-responsive-ad-preview-container .msn-medium-headline .text-container .business-name-with-ads .business-name, .new-responsive-ad-preview-container .msn-in-article .text-container .business-name-with-ads .business-name, .new-responsive-ad-preview-container .msn-small-headline .text-container .business-name-with-ads .business-name, .new-responsive-ad-preview-container .audience-network-square-image .text-container .business-name-with-ads .business-name, .new-responsive-ad-preview-container .msn-restoday .text-container .business-name-with-ads .business-name, .new-responsive-ad-preview-container .msn-partner-stripe .text-container .business-name-with-ads .business-name, .new-responsive-ad-preview-container .audience-network-banner .text-container .business-name-with-ads .business-name, .new-responsive-ad-preview-container .mobile-web-outlook .text-container .business-name-with-ads .business-name': {
    color: '#333',
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel': {
    width: 622,
    height: 368,
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel .text-container .long-headline': {
    width: 575,
    height: 80,
    fontSize: 28,
    lineHeight: '1.214',
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel .text-container .long-headline .multi-line-processed-text': {
    position: 'absolute',
    bottom: 30,
  },
  '& .new-responsive-ad-preview-container .edge-single-carousel': {
    width: 624,
    height: 350,
  },
  '& .new-responsive-ad-preview-container .edge-single-carousel .text-container .short-headline': {
    height: 73,
    fontSize: 28,
    lineHeight: '33.99px',
    width: 590,
    marginBottom: 20,
  },
  '& .new-responsive-ad-preview-container .edge-single-carousel .text-container .short-headline .multi-line-processed-text': {
    position: 'absolute',
    bottom: 30,
  },
  '& .new-responsive-ad-preview-container .edge-carousel': {
    width: 612,
    height: 304,
    border: 0,
  },
  '& .new-responsive-ad-preview-container .edge-carousel .text-container .short-headline': {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: '36px',
    width: 592,
    height: 'auto',
    maxHeight: 108,
    marginBottom: 0,
    color: 'white',
  },
  // '& .new-responsive-ad-preview-container .edge-carousel .text-container .short-headline .multi-line-processed-text': {
  //   position: 'absolute',
  //   bottom: 30,
  // },
  '& .new-responsive-ad-preview-container .edge-carousel:hover': {
    cursor: 'pointer',
  },
  '& .new-responsive-ad-preview-container .edge-carousel:hover .short-headline': {
    textDecoration: 'underline',
    color: 'white',
  },
  '& .new-responsive-ad-preview-container .edge-carousel:hover .gradient::after': {
    marginTop: -450,
    height: 480,
  },
  '& .new-responsive-ad-preview-container .edge-carousel .text-container': {
    position: 'absolute',
    color: '#bebebe',
    left: 0,
    padding: 16,
    bottom: 0,
  },
  '& .new-responsive-ad-preview-container .edge-carousel .gradient::after': {
    display: 'block',
    position: 'relative',
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
    marginTop: -250,
    height: 280,
    width: '100%',
    content: '\'\'',
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel-v2': {
    width: 628,
    height: 372,
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel-v2 .text-container .long-headline': {
    maxHeight: 108,
    fontSize: 28,
    lineHeight: '36px',
    width: 576,
    marginBottom: 0,
    fontWeight: 600,
  },
  '& .new-responsive-ad-preview-container .msn-single-carousel-v2 .text-container .long-headline .multi-line-processed-text': {
    position: 'absolute',
    bottom: 30,
  },
  '& .new-responsive-ad-preview-container .msn-double-carousel': {
    width: 310,
    height: 333,
  },
  '& .new-responsive-ad-preview-container .msn-double-carousel .text-container .short-headline': {
    fontSize: 20,
    lineHeight: '1.3',
    height: 54,
    width: 280,
  },
  '& .new-responsive-ad-preview-container .msn-double-carousel .text-container .short-headline .multi-line-processed-text': {
    position: 'absolute',
    bottom: 30,
  },
  '& .new-responsive-ad-preview-container .audience-network-wide': {
    width: 382,
    height: 364,
    padding: 3,
  },
  '& .new-responsive-ad-preview-container .audience-network-wide .text-container': {
    padding: 10,
  },
  '& .new-responsive-ad-preview-container .audience-network-wide .text-container .short-headline': {
    fontSize: 18,
    lineHeight: '1.2',
    height: 60,
    position: 'relative',
    top: -6,
    color: '#207697',
  },
  '& .new-responsive-ad-preview-container .audience-network-wide .text-container .description': {
    height: 45,
    margin: '5px 0 10px 0',
    fontSize: 14,
  },
  '& .new-responsive-ad-preview-container .audience-network-wide-v2': {
    width: 300,
    height: 304,
    border: 0,
  },
  '& .new-responsive-ad-preview-container .audience-network-wide-v2 .image-container': {
    // position: 'absolute',
    width: 300,
    height: 157,
    left: 0,
    top: 0,
  },
  '& .new-responsive-ad-preview-container .audience-network-wide-v2 .text-container': {
    width: 300,
    height: 147,
    padding: '12px 12px 12px 12px',
    background: 'linear-gradient(112.05deg, #FFFFFF 35.59%, #E1E1E1 100%)',
  },
  // '& .new-responsive-ad-preview-container .audience-network-wide-v2 .text-container .gradient::after': {
  //   // display: 'block',
  //   position: 'relative',
  //   background: 'linear-gradient(to bottom, transparent 0, #E1E1E1 100%)',
  //   // marginTop: -279,
  //   // height: 280,
  //   // width: '100%',
  //   // content: '\'\'',
  // },
  '& .new-responsive-ad-preview-container .audience-network-wide-v2 .text-container .short-headline': {
    width: 268,
    // height: 44,
    fontFamily: 'Segoe UI Variable Static Text',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 20,
    lineHeight: 1.1,
    color: '#1A1A1A',
    position: 'relative',
    top: 0,
  },
  '& .new-responsive-ad-preview-container .audience-network-wide-v2 .text-container .description': {
    width: 268,
    // height: 40,
    fontFamily: 'Segoe UI Variable Static Text',
    fontStyle: 'normal',
    marginTop: 4,
    lineHeight: 1.43,
    fontWeight: 400,
    fontSize: 14,
    color: '#4D4C4C',
  },
  '& .new-responsive-ad-preview-container .audience-network-wide-v2 .text-container .business-name-with-ads .business-name, ': {
    color: '#333',
  },

  '& .new-responsive-ad-preview-container .msn-in-article': {
    width: 300,
    height: 364,
    padding: 3,
  },
  '& .new-responsive-ad-preview-container .msn-in-article .text-container': {
    height: 98,
    padding: 10,
  },
  '& .new-responsive-ad-preview-container .msn-in-article .text-container .short-headline': {
    fontSize: 15,
    lineHeight: '1.2',
    height: 60,
    position: 'relative',
    top: -6,
    overflow: 'hidden',
    color: '#207697',
  },
  '& .new-responsive-ad-preview-container .msn-in-article .text-container .description': {
    height: 45,
    margin: '5px 0 10px 0',
    fontSize: 14,
    color: '#333',
  },
  '& .new-responsive-ad-preview-container .msn-partner-stripe': {
    width: 302,
    height: 296,
    padding: 0,
  },
  '& .new-responsive-ad-preview-container .msn-partner-stripe .text-container': {
    height: 98,
    padding: 10,
    width: 282,
  },
  '& .new-responsive-ad-preview-container .msn-partner-stripe .text-container .long-headline': {
    fontSize: 14,
    width: 282,
    height: 40,
    margin: 0,
    overflow: 'hidden',
    lineHeight: '20px',
    position: 'relative',
    top: -6,
    color: '#2b2b2b',
  },
  '& .new-responsive-ad-preview-container .msn-medium-headline': {
    width: 300,
    height: 296,
    padding: 3,
  },
  '& .new-responsive-ad-preview-container .msn-medium-headline .text-container': {
    height: 98,
    padding: '15px 13px',
  },
  '& .new-responsive-ad-preview-container .msn-medium-headline .text-container .short-headline': {
    fontSize: 15,
    lineHeight: '1.467',
    height: 47,
    position: 'relative',
    top: -6,
    overflow: 'hidden',
  },
  '& .new-responsive-ad-preview-container .edge-medium-headline .text-container .short-headline .multi-line-processed-text': {
    position: 'absolute',
    bottom: 30,
  },
  '& .new-responsive-ad-preview-container .edge-medium-headline': {
    width: 300,
    height: 250,
    backgroundColor: 'rgb(46, 46, 46)',
  },
  '& .new-responsive-ad-preview-container .edge-medium-headline .text-container .short-headline': {
    fontSize: 20,
    lineHeight: '1.3',
    height: 54,
    color: 'white',
    width: 280,
  },
  '& .new-responsive-ad-preview-container .audience-network-square-image': {
    width: 300,
    height: 90,
    padding: 3,
  },
  '& .new-responsive-ad-preview-container .audience-network-square-image .image-container': {
    float: 'left',
    transform: 'none',
    width: 80,
    height: 75,
    margin: 8,
  },
  '& .new-responsive-ad-preview-container .audience-network-square-image .short-headline': {
    fontWeight: '600',
    fontSize: 13,
    lineHeight: '1.384',
    height: 45,
    margin: '8px 8px 0 8px',
    overflow: 'hidden',
  },
  '& .new-responsive-ad-preview-container .audience-network-square-image-v2': {
    margin: 'auto',
    background: '#fff',
    border: 'solid',
    borderWidth: 'thin',
    color: '#ddd',
    width: 240,
    height: 90,
    padding: 3,
  },
  '& .new-responsive-ad-preview-container .audience-network-square-image-v2 .image-container': {
    float: 'right',
    transform: 'none',
    width: 80,
    height: 75,
    margin: 8,
  },
  '& .new-responsive-ad-preview-container .audience-network-square-image-v2 .text-container': {
    marginLeft: 8,
  },
  '& .new-responsive-ad-preview-container .audience-network-square-image-v2 .short-headline': {
    fontWeight: '600',
    fontSize: 14,
    lineHeight: '22px',
    height: 45,
    margin: '8px 0 8px 0',
    overflow: 'hidden',
    color: 'black',
    fontFamily: 'Segoe UI',
  },
  '& .new-responsive-ad-preview-container .msn-restoday': {
    width: 306,
    height: 100,
    padding: 3,
  },
  '& .new-responsive-ad-preview-container .msn-restoday .image-container': {
    float: 'left',
    transform: 'none',
    width: 108,
    height: 84,
    margin: '8px 4px 0 8px',
  },
  '& .new-responsive-ad-preview-container .msn-restoday .text-container': {
    padding: 2,
  },
  '& .new-responsive-ad-preview-container .msn-restoday .text-container .short-headline': {
    fontWeight: '600',
    fontSize: 16,
    lineHeight: '22px',
    overflow: 'hidden',
    color: '#2b2b2b',
    height: 55,
    paddingTop: 5,
  },
  '& .new-responsive-ad-preview-container .audience-network-banner': {
    width: 360,
    height: 88,
    padding: 0,
  },
  '& .new-responsive-ad-preview-container .audience-network-banner .image-container': {
    float: 'left',
    transform: 'none',
    width: 180,
    height: 90,
    marginRight: 10,
  },
  '& .new-responsive-ad-preview-container .audience-network-banner .short-headline': {
    fontWeight: '600',
    fontSize: 15,
    fontFamily: 'Segoe UI Semibold',
    lineHeight: '22px',
    height: 45,
    margin: '8px 8px 0 8px',
    overflow: 'hidden',
    color: 'rgba(0, 0, 0, 0.83)',
  },
  '& .new-responsive-ad-preview-container .msn-small-headline': {
    width: 300,
    height: 90,
    padding: 3,
  },
  '& .new-responsive-ad-preview-container .msn-small-headline .image-container': {
    float: 'left',
    transform: 'none',
    width: 100,
    height: 75,
    margin: 8,
  },
  '& .new-responsive-ad-preview-container .msn-small-headline .short-headline': {
    fontWeight: '600',
    fontSize: 13,
    lineHeight: '1.384',
    height: 52,
    margin: '4px 8px 0 8px',
    overflow: 'hidden',
  },
  '& .new-responsive-ad-preview-container .web-desktop-outlook': {
    margin: '25px auto 0 auto',
    background: '#fff',
    border: 'solid',
    borderWidth: 'thin',
    color: '#ddd',
    height: 25,
    minWidth: 500,
    marginTop: 25,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  '& .new-responsive-ad-preview-container .web-desktop-outlook .ad-logo, .new-responsive-ad-preview-container .web-desktop-outlook .down-arrow, .new-responsive-ad-preview-container .web-desktop-outlook .short-headline, .new-responsive-ad-preview-container .web-desktop-outlook .description-separator, .new-responsive-ad-preview-container .web-desktop-outlook .description, .new-responsive-ad-preview-container .web-desktop-outlook .business-name': {
    display: 'inline-block',
    padding: 4,
  },
  '& .new-responsive-ad-preview-container .web-desktop-outlook .ad-logo': {
    verticalAlign: 'middle',
    backgroundColor: 'blue',
    width: 20,
    borderRadius: 4,
    height: 13,
    marginLeft: 4,
  },
  '& .new-responsive-ad-preview-container .web-desktop-outlook .ad-logo p': {
    position: 'absolute',
    top: 3,
    fontSize: 10,
    color: 'white',
  },
  '& .new-responsive-ad-preview-container .web-desktop-outlook .business-name': {
    marginRight: 40,
    color: 'black',
  },
  '& .new-responsive-ad-preview-container .web-desktop-outlook .down-arrow': {
    border: 'solid gray',
    borderWidth: '0 1.5px 1.5px 0',
    display: 'inline-block',
    padding: 2,
    transform: 'rotate(45deg) translateY(-3px)',
    W: 'rotate(45deg) translateY(-3px)',
    marginRight: 10,
  },
  '& .new-responsive-ad-preview-container .web-desktop-outlook .short-headline': {
    color: 'blue',
  },
  '& .new-responsive-ad-preview-container .web-desktop-outlook .description, .new-responsive-ad-preview-container .web-desktop-outlook .description-separator': {
    color: 'gray',
  },
  '& .new-responsive-ad-preview-container .mobile-web-outlook': {
    width: 340,
    height: 80,
    padding: '5px 10px 5px 15px',
  },
  '& .new-responsive-ad-preview-container .mobile-web-outlook .ad-logo, .new-responsive-ad-preview-container .mobile-web-outlook .business-name': {
    display: 'inline-block',
    padding: 4,
    overflow: 'hidden',
    maxWidth: 300,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    height: 30,
    fontSize: 20,
    verticalAlign: 'middle',
  },
  '& .new-responsive-ad-preview-container .mobile-web-outlook .ad-logo': {
    verticalAlign: 'middle',
    backgroundColor: '#006ed4',
    width: 20,
    borderRadius: 4,
    height: 15,
  },
  '& .new-responsive-ad-preview-container .mobile-web-outlook .ad-logo p': {
    position: 'absolute',
    top: 11.5,
    fontSize: 10,
    color: 'white',
  },
  '& .new-responsive-ad-preview-container .mobile-web-outlook .business-name': {
    color: 'black',
    paddingTop: 6,
  },
  '& .new-responsive-ad-preview-container .mobile-web-outlook .short-headline': {
    color: '#1081d9',
  },
  '& .new-responsive-ad-preview-container .mobile-web-outlook .description': {
    color: 'gray',
    padding: '0',
  },
  '& .new-responsive-ad-preview-container .mobile-web-outlook .description, .new-responsive-ad-preview-container .mobile-web-outlook .short-headline': {
    fontSize: 13,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginTop: 2,
  },
});
